import { render, staticRenderFns } from "./WidgetList.vue?vue&type=template&id=706b0a3a&scoped=true&"
import script from "./WidgetList.vue?vue&type=script&lang=js&"
export * from "./WidgetList.vue?vue&type=script&lang=js&"
import style0 from "./WidgetList.vue?vue&type=style&index=0&id=706b0a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706b0a3a",
  null
  
)

export default component.exports